import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DataStorageService } from './core';

@Component({
  selector: 'pkp-g-root',
  imports: [RouterModule],
  template: `<router-outlet></router-outlet>`,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  private readonly dataStorageService = inject(DataStorageService);
  private readonly location = inject(Location);

  ngOnInit(): void {
    this.listenTokenParams();
  }

  private listenTokenParams(): void {
    const urlParams = new URLSearchParams(this.location.path().split('?')[1] || '');
    const accessToken = urlParams.get('accessToken');
    const refreshToken = urlParams.get('refreshToken');

    if (accessToken && refreshToken) {
      this.dataStorageService.setTokens(accessToken, refreshToken);
    }
    const urlWithoutParams = this.location.path().split('?')[0];
    this.location.replaceState(urlWithoutParams);
  }
}
